import Marquee from "react-fast-marquee";
import logo01 from "../../images/brand/logo/logo1.png";
import logo02 from "../../images/brand/logo/logo2.png";
import logo03 from "../../images/brand/logo/logo3.png";
import logo04 from "../../images/brand/logo/logo4.png";
import logo05 from "../../images/brand/logo/logo5.png";
import logo06 from "../../images/brand/logo/logo6.png";
import logo07 from "../../images/brand/logo/logo7.png";
import logo08 from "../../images/brand/logo/logo8.png";
import logo09 from "../../images/brand/logo/logo9.png";
import logo10 from "../../images/brand/logo/logo10.png";
import logo11 from "../../images/brand/logo/logo11.png";
import logo12 from "../../images/brand/logo/logo12.png";



const BrandSection: React.FC = () => {
    return (
        <section className="brand pt-170 pb-150" >
            <div className="container">
                <div className="xb-brand-wrap xb-border">
                    <div className="brand-sub-title xb-border">
                        <p>
                            World's Best <span>Brands</span> Work With Us
                        </p>
                    </div>


                    <Marquee speed={40} gradient={false} pauseOnHover={false}>
                        <div className="brand-marquee marquee-left">
                            <div className="xb-brand-inner ul_li_between">
                                {[logo01, logo02, logo03, logo04, logo05, logo06, logo07, logo08, logo09, logo10, logo11, logo12].map(
                                    (logo, index) => (
                                        <div className="xb-brand-item" key={index}>
                                            <img src={logo} alt={`logo ${index + 1}`} />
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </Marquee>

                </div>
            </div>
        </section>
    );
};

export default BrandSection;


